<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import Identity from 'svelte-key'
	import Node from '../shared/sidebar/Node.svelte';
	import { person, logOut, helpCircleOutline, addCircleOutline, settings, cube, map, headset, videocam, document, link, bookmark, refresh, image, grid } from 'ionicons/icons/index.mjs';
	import { projectSort } from '../shared/utils/Sort.svelte';
	import { getLocalServer } from '../shared/utils/Data.svelte';

	export let vitals;
  export let mapId;
	export let keys;
	export let tooltips;
	export let config;
	export let isPublic;

	let filter = "";

	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
	}
	function filterHandler() {
		sendMessage({
			type: "filter"
		})
	}
</script>

<div id="tree" class="panel">
	<div class="panel-body">
		<div class="tile tile-centered pr-2 pl-2">
        <div class="tile-content">
            <div class="divider" data-content="PROJECT TREE"></div>
        </div>
    </div>
    <Identity key={keys.project}>
        {#if config}
            {#if Object.keys(config.tree).length > 0}
                {#each Object.keys(config.tree) as section}
                    {#if section != "tables"}
                        {#if config.tree[section].child_count == 0}
                            <ul class="menu menu-nav">
                                <div class="tile tile-centered">
                                    <div class="tile-content tile-tree">
                                        <li class="menu-item {mapId == config.tree[section].id ? "active" : ""}">{config.tree[section].name}</li>
                                    </div>
                                    <div class="tile-action">
                                        {#if config.tree[section].type == "map"}
                                            <a href={isPublic ? "/maps/" + config.tree[section].id + "?public" : "/maps/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Map">
                                                <i class="svg">{@html map.md}</i>
                                            </a>
                                        {:else if config.tree[section].type == "scene"}
                                            <a href={isPublic ? "/scenes/" + config.tree[section].id + "?public" : "/scenes/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Scene">
                                                <i class="svg">{@html cube.md}</i>
                                            </a>
                                        {:else if config.tree[section].type == "table"}
                                            <a href={isPublic ? "/tables/" + config.tree[section].id + "?public" : "/tables/" + config.tree[section].id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                                                <i class="svg">{@html grid.md}</i>
                                            </a>
                                        {/if}
                                    </div>
                                </div>
                            </ul>
                        {:else}
                            <Node tooltips={tooltips} mapId={mapId} node={config.tree[section]} isPublic={isPublic} />
                        {/if}
                    {/if}
                {/each}
                {#if config.tree.tables && config.tree.tables.length > 0}
                    <div class="tile tile-centered pr-2 pl-2">
                            <div class="tile-content">
                                    <div class="divider" data-content="TABLES"></div>
                            </div>
                    </div>
                    {#each config.tree.tables as table}
                        <ul class="menu menu-nav">
                            <div class="tile tile-centered">
                                <div class="tile-content tile-tree">
																	<li class="menu-item {mapId == table.id ? "active" : ""}">{table.name}</li>
                                </div>
                                <div class="tile-action">
                                    <a href={isPublic ? "/tables/" + table.id + "?public" : "/tables/" + table.id} class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View Table">
                                        <i class="svg">{@html grid.md}</i>
                                    </a>
                                </div>
                            </div>
                        </ul>
                    {/each}
                {/if}
            {/if}
        {/if}
    </Identity>
	</div>
	<div class="panel-footer">
	<div class="tile tile-centered">
			<div class="tile-content">
				<div class="btn-group slant slant-right-reverse">
          <a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href="/" data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Settings" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "modal",
						data: {
								view: "settings"
						}
					})
					}}><i class="svg svg-light">{@html settings.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Sign Out" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "session",
						data: {
							workspaces: ""
						}
					})
					}}><i class="svg svg-light">{@html logOut.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Help" on:click={async (e) => {
						e.currentTarget.blur();
						if (window.platform == "Windows") {
							await fetch(getLocalServer() + "/help")
						}
						else {
							window.open("https://help.geosync.cloud");
						}
					}}><i class="svg svg-light">{@html helpCircleOutline.md}</i></button>
				</div>
			</div>
			<div class="tile-action version">
					{ vitals.version }
			</div>
		</div>
	</div>
</div>

<style>
	.version {
		font-size: 80%;
		margin-top: 15px;
		margin-right: 5px;
	}
    #tree {
        position: fixed;
        overflow-y: auto;
        width: 300px;
        height: 100%;
	}
	#filterContainer {
		margin-top: -0.6rem;
	}
	.form-group {
		margin: 0;
	}
	.panel {
        border: 0;
	}
	.panel .panel-body {
		padding: 0;
    }
	.panel .panel-footer {
		padding: 0;
		background: #efefef;
	}
	.menu {
        padding: 0 0 0 0.8rem;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
		border: 0;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
	.menu-item.active {
		color: #00ab5f;
	}
	.svg {
		fill: #00ab5f;
	}
	.slant {
		color: white;
		background-color: #00ab5f;
		transform-origin: bottom left;
		position: relative;
		z-index: 1;
	}
	.slant-right-reverse:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		right: 0;
		width: 20px;
		margin-right: -10px;
		background-color: #00ab5f;
		border-right: 2px solid #a9d9bb;
		-ms-transform: skew(30deg, 0deg);
		-webkit-transform: skew(30deg, 0deg);
		transform: skew(30deg, 0deg);
	}
	.slant .btn.btn-link {
		color: white;
	}
</style>
